import { gql } from '@apollo/client'
import { USER_FRAGMENT } from './UserFragment'
import { DISPLAY_FRAGMENT } from './DisplayFragment'

export const TASK_FRAGMENT = gql`
  fragment Task on TaskBase {
    id
    description
    assignedUser {
      ...User
    }
    createdBy {
      ...User
    }
    store {
      id
      name
    }
    progress {
      status
      dateCompleted
      user {
        ...User
      }
      created
      modified
      errorMessage
    }
    created
    modified
    ... on DisplayTask {
      __typename
      description
      taskType
      display {
        ...Display
      }
    }
  }
  ${USER_FRAGMENT}
  ${DISPLAY_FRAGMENT}
`
